import { View } from 'react-native';
import RNToast, {
  type BaseToastProps,
  type ToastProps,
} from 'react-native-toast-message';
import { StyleSheet } from 'react-native-unistyles';
import Text from '@/components/UI/Text';
import useAppState from '@/hooks/useAppState';
import { notificationAsync } from '@/utils/Haptics';

type ToastTone = 'success' | 'error' | 'warning' | 'info';

function Toast(toastProps: ToastProps) {
  const config = {
    error: (props: BaseToastProps) => <ToastContent tone="error" {...props} />,
    info: (props: BaseToastProps) => <ToastContent tone="info" {...props} />,
    success: (props: BaseToastProps) => (
      <ToastContent tone="success" {...props} />
    ),
    warning: (props: BaseToastProps) => (
      <ToastContent tone="warning" {...props} />
    ),
  };

  const onShow = () => {
    notificationAsync();
  };

  useAppState();

  return (
    <RNToast
      config={config}
      onShow={onShow}
      visibilityTime={3000}
      {...toastProps}
    />
  );
}

export default Toast;

function ToastContent({
  text1,
  text2,
  tone,
}: BaseToastProps & {
  tone: ToastTone;
}) {
  style.useVariants({
    tone,
  });

  return (
    <View style={style.container}>
      {text1 ? (
        <Text size="lg" variant="white">
          {text1}
        </Text>
      ) : null}
      {text2 ? (
        <Text size="sm" variant="white">
          {text2}
        </Text>
      ) : null}
    </View>
  );
}

const style = StyleSheet.create((theme) => ({
  container: {
    marginTop: 0,
    padding: theme.space('xl'),
    width: '100%',
    variants: {
      tone: {
        error: {
          backgroundColor: theme.colors.error,
        },
        info: {
          backgroundColor: theme.colors.info,
        },
        success: {
          backgroundColor: theme.colors.success,
        },
        warning: {
          backgroundColor: theme.colors.warning,
        },
      },
    },
  },
}));
